export default __webpack_public_path__ + "static/media/Ballroll_00317.540bce5e.png";